"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialAndTopBtn = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const BackToTopBtn_atom_1 = require("../atoms/BackToTopBtn.atom");
const SocialIcons_molecule_1 = require("./SocialIcons.molecule");
const classnames_1 = __importDefault(require("classnames"));
const Styled = styled_components_1.default.div `
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    margin-bottom: 40px;

    &.ar {
        direction: rtl;
    }
`;
const SocialAndTopBtn = ({ socialLinks = [], locale }) => {
    return (react_1.default.createElement(Styled, { className: (0, classnames_1.default)(locale) },
        react_1.default.createElement(SocialIcons_molecule_1.SocialIcons, { socialLinks: socialLinks }),
        react_1.default.createElement(BackToTopBtn_atom_1.BackToTopBtn, null)));
};
exports.SocialAndTopBtn = SocialAndTopBtn;
//# sourceMappingURL=SocialAndTopBtn.molecule.js.map